"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Rels_1 = require("../models/Rels");
const WmsRestClient_1 = require("../WmsRestClient");
class WmsEventAccessor {
    constructor(wmsRestClient) {
        if (!wmsRestClient) {
            const billboardHost = process.env.WMS_BILLBOARD_HOST;
            if (!billboardHost) {
                throw new Error('WMS_BILLBOARD_HOST must be present in the process environment');
            }
            // Not required in the environment, will be used if provided
            const s3BillboardUrl = process.env.WMS_S3_BILLBOARD_URL ?? '';
            const wmsAuthBasic = process.env.WMS_AUTH_BASIC;
            if (!wmsAuthBasic) {
                throw new Error('WMS_AUTH_BASIC must be present in the process environment');
            }
            wmsRestClient = new WmsRestClient_1.WmsRestClient(billboardHost, s3BillboardUrl);
            wmsRestClient.wmsHost = billboardHost;
            wmsRestClient.wmsAuthBasic = wmsAuthBasic;
        }
        this._wmsRestClient = wmsRestClient;
    }
    _wmsRestClient;
    async getEvents(tplGuid, lastRequestedWmsEventId, pgsize, pgnumber, reverseSort) {
        const URI = await this._wmsRestClient.billboardUri(Rels_1.Rels.ToolSvc.WMSEventList);
        const sort = reverseSort === true ? 'true' : 'false';
        const params = {
            reversesort: sort,
            reverseSort: sort,
        };
        if (lastRequestedWmsEventId) {
            params.lastRequestedWMSEventId = `${lastRequestedWmsEventId}`;
            params.lastrequestedwmseventid = `${lastRequestedWmsEventId}`; // TODO: remove when the billboard for staging gets updated
        }
        if (pgsize) {
            params.pgsiz = `${pgsize}`;
        }
        if (pgnumber) {
            params.pgnum = `${pgnumber}`;
        }
        const wmsEventsURI = this._wmsRestClient.substituteValues(URI.href, params);
        return this._wmsRestClient.get(wmsEventsURI, tplGuid);
    }
}
exports.default = WmsEventAccessor;
